module.exports = '<svg width="35" height="32" viewBox="0 0 35 32"><path d="M0 27.636v2.909C0 31.348.652 32 1.455 32h32c.803 0 1.455-.652 1.455-1.455v-2.909c0-.803-.652-1.455-1.455-1.455h-32c-.803 0-1.455.652-1.455 1.455zm2.909-7.272H32a2.907 2.907 0 0 0 2.057-4.966L19.512.853a2.906 2.906 0 0 0-4.113 0L.854 15.398a2.909 2.909 0 0 0 2.057 4.966z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/eject-1.js
// module id = 1124
// module chunks = 14